var __assign = (this && this.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [0, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { AlertController, PopoverController } from 'ionic-angular';
import { AnalyticsService, ConfigService, FeaturesService, PreferencesService } from '@apto/services';
import { FieldCheckModal } from '../../modals/field-check-modal/field-check-modal';
import { END_POINTS } from '../../constants';
import { IonicTokenService } from '../ionic-token-service/ionic-token-service';
import moment from 'moment-timezone';
import { DesktopPreferencesModel } from '@apto/models';
var AuthService = /** @class */ /*@__PURE__*/ (function () {
    function AuthService(analyticsService, featuresService, configService, http, popoverController, tokenService, preferences, alertController) {
        var _this = this;
        this.analyticsService = analyticsService;
        this.featuresService = featuresService;
        this.configService = configService;
        this.http = http;
        this.popoverController = popoverController;
        this.tokenService = tokenService;
        this.preferences = preferences;
        this.alertController = alertController;
        this.onSetUser = new BehaviorSubject(null);
        this.onDisplayFieldCheck = new EventEmitter();
        this.checkLogin = function () {
            return __awaiter(_this, void 0, void 0, function () {
                var token;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.tokenService.getToken()];
                        case 1:
                            token = _a.sent();
                            if (token) {
                                return [2 /*return*/, this.getUser()];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        this.getUser = function () {
            return new Promise(function (resolve) {
                _this.http.get(_this.configService.serviceUrl + "/" + END_POINTS.CHECK_LOGIN)
                    .subscribe(function (userInfo) {
                    if (!userInfo.id) {
                        if (_this.loginNavHandler) {
                            _this.loginNavHandler(null);
                        }
                        return resolve(null);
                    }
                    if (userInfo.enabledFeatures) {
                        _this.featuresService.setEnabledFeatures(JSON.parse(userInfo.enabledFeatures));
                    }
                    return resolve(userInfo);
                }, function () {
                    return resolve(null);
                });
            });
        };
        this.trackLogin = function (user, fieldCheckData) {
            if (!_this.analyticsService.isEnabled() || !user || !_this.configService.segmentKey) {
                return;
            }
            if (!AuthService.segmentKeyLoaded) {
                _this.analyticsService.loadSegmentKey(_this.configService.segmentKey);
                AuthService.segmentKeyLoaded = true;
            }
            var traits = Object.assign({}, user);
            traits.isTrial = fieldCheckData.isTrialOrg;
            traits.isUpgraded = !fieldCheckData.isUpgradeRequired;
            delete traits.segmentKey; // the current API returns the segment key for the user to use. this needs to be deprecated.
            _this.analyticsService.identify(user.legacyUserId || user.id, traits);
            _this.analyticsService.logEvent(fieldCheckData.isUpgradeRequired ? 'Version requirement not met' : 'Log in');
        };
        this.checkInstallState = function (user) {
            return new Promise(function (resolve, reject) {
                if (user && user.appState) {
                    var _a = user.appState, baseUrl = _a.baseUrl, installed = _a.installed;
                    var linkWrap = function (url) { return "<a href=\"" + url + "\" target=\"_blank\" rel=\"noopener noreferrer\"><b>link</b></a>"; };
                    if (!installed) {
                        var actLink = baseUrl + "/identity/app/connectedAppsUsage.apexp?setupid=ConnectedAppsUsage";
                        var helpLink = 'https://help.salesforce.com/s/articleView?id=005132365&type=1';
                        var alert_1 = _this.alertController.create({
                            title: 'Completing the installation',
                            subTitle: "\n                        <div class=\"content\">\n                        Due to a change in Salesforce's application activation policy, you must activate the application manually to complete the installation.\n                        </br>\n                        Follow this " + linkWrap(actLink) + " and activate the application as shown in the screenshot:\n                        <p>\n                        <img src=\"/images/install-app.png\"/>\n                        </p>\n                        Otherwise, the application will only be available to users with Administrator rights.\n                        </br>\n                        For more information, see the following article: " + linkWrap(helpLink) + "\n                        </div>",
                            enableBackdropDismiss: false,
                            buttons: [{ role: 'OK', text: 'DONE' }],
                            cssClass: 'alert-massage-info',
                        });
                        alert_1.onDidDismiss(function (data, role) {
                            resolve(user);
                        });
                        alert_1.present();
                    }
                    else {
                        resolve(user);
                    }
                }
                else {
                    resolve(user);
                }
            });
        };
        this.checkMissingFields = function (user) {
            return new Promise(function (resolve, reject) {
                _this.http.get(_this.configService.serviceUrl + "/" + END_POINTS.FIELD_CHECK, { observe: 'response' })
                    .subscribe(function (response) {
                    if (!response.url.startsWith(_this.configService.serviceUrl) ||
                        response.status !== 200) {
                        resolve(true);
                    }
                    var data = response.body.data;
                    _this.trackLogin(user, data);
                    if (data.objects.length || data.fields.length || data.isUpgradeRequired) {
                        _this.displayFieldCheckModal(data)
                            .then(function (result) {
                            return resolve(result);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    else {
                        return resolve(true);
                    }
                }, function () {
                    // for now, resolve with true. default assumption is that the org is okay.
                    return resolve(true);
                });
            });
        };
    }
    AuthService.prototype.checkLoginAndNavigate = function () {
        var _this = this;
        var user;
        return this.checkLogin()
            .then(this.checkInstallState)
            .then(function (loginResult) {
            user = loginResult;
            if (user) {
                _this.checkStoreOverflow(user.storageState);
                _this.checkTZ(user.timezone);
                _this.checkEnvSettings(user.envSettings);
                return _this.checkMissingFields(user);
            }
            else {
                return Promise.resolve(null);
            }
        })
            .then(function (missingFields) {
            if (user && missingFields && _this.loginNavHandler) {
                _this.user = user;
                _this.onSetUser.next(user);
                _this.loginNavHandler(user);
            }
            else if (_this.loginNavHandler) {
                _this.loginNavHandler(null);
            }
            return Promise.resolve(user && missingFields);
        });
    };
    AuthService.prototype.logout = function () {
        this.analyticsService.logEvent('Log out');
        this.user = null;
        this.logoutNavHandler();
    };
    AuthService.prototype.checkStoreOverflow = function (storeStatus) {
        if (storeStatus === 'overflowed') {
            this.alertController
                .create({
                title: 'Warning',
                subTitle: 'Storage limit is exceeded. Application functionality may be affected...',
                buttons: [{ role: 'OK', text: 'OK' }],
                cssClass: 'alert-massage-info',
            })
                .present();
        }
    };
    AuthService.prototype.getTZString = function (date) {
        var offset = (date.utcOffset() / 60);
        return "GMT" + (offset > 0 ? '+' : '') + offset.toPrecision(1);
    };
    AuthService.prototype.checkTZ = function (sfUserTZ) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var sfUserDate, browserDate, settings, hide, alert_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sfUserDate = moment.utc().tz(sfUserTZ);
                        browserDate = moment();
                        return [4 /*yield*/, this.preferences.fetch()];
                    case 1:
                        settings = _a.sent();
                        hide = settings && settings.configJson ? settings.configJson['tzErrorHide'] : false;
                        if (sfUserDate.format('Z') !== browserDate.format('Z') && !hide) {
                            alert_2 = this.alertController.create({
                                title: 'Warning',
                                subTitle: "System and Salesforce time zone settings do not match ( System: " + this.getTZString(browserDate) + ", Salesforce: " + this.getTZString(sfUserDate) + "). Activity dates may not be displayed correctly. To fix it, set the same time zone in the system and in SF settings.",
                                inputs: [
                                    {
                                        checked: false,
                                        type: 'checkbox',
                                        label: 'Do not show this message again',
                                        value: 'tzErrorHide',
                                    },
                                ],
                                buttons: [{ role: 'OK', text: 'OK' }],
                                cssClass: 'alert-massage-info-tz',
                            });
                            alert_2.onDidDismiss(function (data, role) {
                                if (data.includes('tzErrorHide')) {
                                    var obj = new DesktopPreferencesModel(settings);
                                    obj.configJson = __assign({}, obj.configJson, { tzErrorHide: true });
                                    _this.preferences.upsert(obj);
                                }
                            });
                            alert_2.present();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthService.prototype.checkEnvSettings = function (data) {
        //empty data - some faults in request to SF
        if (!Object.keys(data).length && !window.location.href.includes('login')) {
            this.user = null;
            this.tokenService.clearToken();
            document.location.replace('/');
        }
    };
    AuthService.prototype.displayFieldCheckModal = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // there are currently 5 Apto-specific objects in the field check.
            // if we are missings that amount or more then we assume that Apto is not installed.
            var isAptoMissing = (data.objects.length >= 5);
            var isUpgradeRequired = data.isUpgradeRequired;
            var fieldCheckModal = _this.popoverController.create(FieldCheckModal, {
                missingFields: data.fields,
                missingObjects: data.objects,
                isAptoMissing: isAptoMissing,
                isUpgradeRequired: isUpgradeRequired
            }, {
                cssClass: 'large-popover-modal loading-popover-modal',
                enableBackdropDismiss: (isAptoMissing || isUpgradeRequired)
            });
            if (isAptoMissing || isUpgradeRequired) {
                reject('Required Apto version not found.');
            }
            else {
                fieldCheckModal.onDidDismiss(function (isFixed) {
                    return resolve(isFixed === true);
                });
            }
            fieldCheckModal.present();
        });
    };
    AuthService.segmentKeyLoaded = false;
    return AuthService;
}());
export { AuthService };
